export default "__VITE_ASSET__B6v9739G__"